module.exports = __webpack_public_path__ + "img/sh_hga.d0289dc0.png";